import { GroupService } from 'data/services';
import { GroupServiceInterface } from 'domain/services';
import { makeRemoteAddPersonToGroup } from 'main/factories/usecases/groups/remote-add-person-to-group-factory';
import { makeRemoteAddPlaceToGroup } from 'main/factories/usecases/groups/remote-add-place-to-group-factory';
import { makeGetAllArchivedGroups } from 'main/factories/usecases/groups/remote-get-all-archived-groups-factory';
import { makeRemoteGetAllGroupsNotPaginated } from 'main/factories/usecases/groups/remote-get-all-groups-not-paginated-factory';
import { makeGetAllGroupsUser } from 'main/factories/usecases/groups/remote-get-all-groups-user-factory';
import { makeRemoteGetAllPersonsFromGroup } from 'main/factories/usecases/groups/remote-get-all-persons-from-group-factory';
import { makeRemoteGetAllPlacesFromGroup } from 'main/factories/usecases/groups/remote-get-all-places-from-group-factory';
import { makeRemoteGetGroupById } from 'main/factories/usecases/groups/remote-get-group-by-id-factory';
import { makeGetGroupList } from 'main/factories/usecases/groups/remote-group-list-factory';
import { makeRemoteImportPersonsFromAnotherGroup } from 'main/factories/usecases/groups/remote-import-persons-from-another-group-factory';
import { makeRemoteImportPlacesFromAnotherGroup } from 'main/factories/usecases/groups/remote-import-places-from-another-group-factory';
import { makeRemoteRemovePersonFromGroup } from 'main/factories/usecases/groups/remote-remove-person-from-group-factory';
import { makeRemoteRemovePlaceFromGroup } from 'main/factories/usecases/groups/remote-remove-place-from-group-factory';

export const makeGroupService = (): GroupServiceInterface => {
  return new GroupService(
    makeGetAllGroupsUser(),
    makeGetGroupList(),
    makeRemoteGetAllGroupsNotPaginated(),
    makeRemoteGetGroupById(),
    makeGetAllArchivedGroups(),
    makeRemoteAddPersonToGroup(),
    makeRemoteRemovePersonFromGroup(),
    makeRemoteAddPlaceToGroup(),
    makeRemoteRemovePlaceFromGroup(),
    makeRemoteGetAllPersonsFromGroup(),
    makeRemoteGetAllPlacesFromGroup(),
    makeRemoteImportPersonsFromAnotherGroup(),
    makeRemoteImportPlacesFromAnotherGroup(),
  );
};
